import { noraWebTheme } from "./noraWebTheme";

export const TableStyling = {
  [noraWebTheme.breakpoints.down('sm')]: {
    width:'100vw',
  },
  [noraWebTheme.breakpoints.up('sm')]: {
    width:'400',
  },
  b:'none',
}

export const DateCellStyling = {
  fontWeight : 'bold',
  border:'none',
  paddingLeft:'5px',
  paddingTop:'1px',
  minWidth: '60px',
  verticalAlign: 'top',
}

export const PlainDateCellStyling = {
  border:'none',
  paddingLeft:'5px',
  minWidth: '60px',
  fontWeight:'normal',
}

export const ContentCellStyling = {
  border:'none',
}

export const ContainerStyling = {
  backgroundColor: 'background.paper',
  flexGrow:1,
  border:'none',
}

export const HeadingStyling = {
  [noraWebTheme.breakpoints.down('md')]: {
    fontSize: '1.3rem',
  },
  [noraWebTheme.breakpoints.up('md')]: {
    fontSize: '1.56rem',
  },
  marginTop:5,
  marginBottom:1,
  textDecoration: 'underline',
  fontWeight:'bold',
  textAlign:'left',
  backgroundColor: 'background.paper',
}

export const TableRowStyling = {
'&:last-child td, &:last-child th': { border: 'none' ,margin:0}
}

export const CellTypographyStyling = {
  [noraWebTheme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
  [noraWebTheme.breakpoints.up('md')]: {
    fontSize: '1.2rem',
  },
}